import React, { Fragment } from 'react'

import { Helmet } from 'react-helmet'

import Header from '../components/header'
import { headerProps } from '../components/HeaderConfig'
import Article from '../components/article'
import Footer from '../components/footer'
import './sample.css'

const Sample = (props) => {
  return (
    <div className="sample-container">
      <Helmet>
        <title>sample - Abhishek Palit</title>
        <meta property="og:title" content="sample - Abhishek Palit" />
      </Helmet>
      <Header {...headerProps} rootClassName="headerroot-class-name" />
      <Article
        text={
          <Fragment>
            <span className="sample-text19">
              <span>Latest issue</span>
              <br></br>
            </span>
          </Fragment>
        }
        text2={
          <Fragment>
            <span className="sample-text22">
              BIM is used by designers at architecture firms, engineers,
              builders at construction firms, and by operations and maintenance
              specialists, and building owners.
            </span>
          </Fragment>
        }
        text3={
          <Fragment>
            <span className="sample-text23">
              <span>
                Building information modeling (BIM) is a digital platform; a
                visualization tool; and, most important, a way of working in the
                architecture, engineering, construction, and operations (AECO)
                industry that translates the unpredictable and dynamic work of
                design and building into data and organizes it. It's the
                fundamental front for innovation in the design and construction
                world that's intimately connected to nearly every other
                industry-wide technological innovation in a sector of the
                economy in sore need of it. According to McKinsey, large
                construction projects typically take 20% longer to finish and
                are 80% over budget on average. Construction-sector productivity
                has declined since the 1990s, and it's one of the least
                digitalized sectors of the economy, second only to agriculture
                and hunting.
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <br></br>
              <br></br>
              <span>
                This state of affairs is a result of the extreme fragmentation
                and atomization of the AECO industry, which is organized as a
                network of regional and local firms working on wildly different
                project types in varied geographies, each addressing local
                conditions and regulations. Essentially, each new building is a
                prototype created by siloed builders and designers, where
                standardization and uniformity are rare. This makes it difficult
                to capture, share, and use data that could streamline
                production, as is done in more unified industries, such as
                manufacturing.
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <br></br>
              <br></br>
              <span>
                BIM for AECO is used by designers at architecture firms,
                engineers, builders at construction firms, and both operations
                and maintenance specialists, as well as building owners
                themselves. Every phase of a building's conception and operation
                can benefit from BIM. By sharing a 3D model of a building
                embedded with data that defines its properties (materials,
                dimensions, spatial relationships, energy performance, and much
                more) with the entire team across the cloud, BIM offers
                incredible control over the entire process.
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
            </span>
          </Fragment>
        }
        text4={
          <Fragment>
            <span className="sample-text31">
              Image Caption: Maya Wind expose how Israeli universities are
              deeply embedded in the machinery of occupation
            </span>
          </Fragment>
        }
        text5={
          <Fragment>
            <span className="sample-text32">
              <span>
                Building information modeling (BIM) technology is unifying the
                construction process in the digital world, bringing untold
                benefits and new ways of working.
              </span>
              <br></br>
              <br></br>
            </span>
          </Fragment>
        }
        text31={
          <Fragment>
            <span className="sample-text36">
              <span>
                BIM offers comprehensive benefits across the construction
                lifecycle, from streamlined collaboration to improved outcomes:
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <br></br>
              <br></br>
              <span>
                1. Improved collaboration and communication
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <br></br>
              <span>
                When BIM is shared across an entire project team, from the
                owners to the subcontractors, everyone is able to operate from a
                continually updated single source of truth, thus dramatically
                reducing the need for lengthy RFIs and crisscrossing emails. The
                model itself becomes the venue for answering questions, not a
                data set buried anonymously on a colleague's hard drive. With
                greater and greater degrees of automation, BIM coordination
                technology can generate reports and metrics, disseminating them
                to the relevant team members.
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <br></br>
              <br></br>
              <span>
                2. Enhanced visualization
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <br></br>
              <span>
                Fundamentally, BIM is a modeling tool that requires buildings to
                be conceived of as a 3D object. This makes it a superior
                visualization tool, both for architects to refine their designs
                and to make their pitches to the owners footing the bill.
                Similarly, builders and engineers can use this visualization
                capability to peel back layers of structure and facade to better
                understand thorny and complex problems before they're committed
                to in steel and concrete. Public projects that require broad
                buy-in from diverse communities benefit immeasurably from BIM's
                visualization features, as they offer the granular detail
                necessary to accurately convey the program and function of any
                building.
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <br></br>
              <br></br>
              <span>
                3. Enhanced resource management
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <br></br>
              <span>
                The purpose of BIM's digital transformation is to drive
                efficiency and the savvy deployment of resources at every turn.
                Because BIM codifies the building process into data, it's an
                invaluable aid for assessing building components and budgeting
                for them, often automating the takeoff process with a far
                greater degree of accuracy than manual counting.
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
            </span>
          </Fragment>
        }
        text41={
          <Fragment>
            <span className="sample-text53">
              Image Caption: Maya Wind expose how Israeli universities are
              deeply embedded in the machinery of occupation
            </span>
          </Fragment>
        }
        heading={
          <Fragment>
            <span className="sample-text54">
              What is building information modeling (BIM)?
            </span>
          </Fragment>
        }
        text311={
          <Fragment>
            <span className="sample-text55">
              #enhanced #resource #management
            </span>
          </Fragment>
        }
        heading2={
          <Fragment>
            <span className="sample-text56">
              10 benefits of building information modeling
            </span>
          </Fragment>
        }
        imageSrc="/hero%20%232-1500w.png"
        imageSrc1="/pexels-darina-belonogova-7959815%201-1500w.png"
        rootClassName="articleroot-class-name"
      ></Article>
      <Footer
        imageSrc22="/linkedin_logo-200h.png"
        rootClassName="footerroot-class-name3"
      ></Footer>
    </div>
  )
}

export default Sample
